import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import store from './store';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import { oidcSettings } from './oidc';
import { enterCampaignsScene } from '@/campaigns/firstRun';

const routes: RouteRecordRaw[] = [
    {
        // sessionId is a campaign id. The map to show is decided at load time by activating the
        // campaign's first map, so it was never addressable here.
        path: '/play/:sessionId',
        name: 'live-play',
        // @ts-expect-error Vue component dynamic imports need type declaration
        component: () => import('@/table/components/LivePlay'),
        props: (route) => ({
            hideUi: route.query.hideUi === 'true',
            sessionId: route.params.sessionId,
        }),
    },
    {
        path: '/oidc',
        name: 'oidcCallback',
        component: () => import('@/app/components/OidcCallback.vue'),
        meta: { isOidcCallback: true },
    },
    {
        path: '/oidc-callback-error',
        name: 'oidc-callback-error',
        component: () => import('@/app/components/OidcCallbackError.vue'),
        meta: { isPublic: true },
    },
    {
        path: '/',
        name: 'layout',
        // @ts-expect-error Vue component dynamic imports need type declaration
        component: () => import('@/campaigns/components/Manager'),
        children: [
            {
                path: '',
                // @ts-expect-error Vue component dynamic imports need type declaration
                component: () => import('@/campaigns/components/CampaignList'),
                name: 'campaign-list',
                beforeEnter: () => enterCampaignsScene(store),
            },
            {
                path: 'invite/:id',
                // @ts-expect-error Vue component dynamic imports need type declaration
                component: () => import('@/campaigns/components/CampaignInvitation'),
                name: 'campaign-invite',
            },
            {
                path: 'edit/:id?',
                // @ts-expect-error Vue component dynamic imports need type declaration
                component: () => import('@/campaigns/components/CampaignEditPage'),
                name: 'campaign-edit',
                alias: 'create',
            },
            {
                path: 'library',
                // @ts-expect-error Vue component dynamic imports need type declaration
                component: () => import('@/campaigns/components/LibraryPage'),
                name: 'library-page',
            },
            {
                path: ':pathMatch(.*)*',
                // @ts-expect-error Vue component dynamic imports need type declaration
                component: () => import('@/campaigns/components/CampaignList'),
                name: 'campaign-list-catchall',
                beforeEnter: () => enterCampaignsScene(store),
            },
        ],
    },
    {
        path: '/ext/auth/profile',
        name: 'profile',
        redirect: () => {
            (window.location.href as any) =
                `${oidcSettings.authority}/account?referrer=${oidcSettings.clientId}&referrer_uri=${window.location.href}`;
            return '/redirecting';
        },
    },
];

export const newTabRoutes = {
    campaigns: function () {
        const newTabAddress = router.resolve({ name: 'campaign-list' });
        window.open(newTabAddress.href, '_blank', 'noopener,noreferrer');
    },
    accountProfile: function () {
        const newTabAddress = `${oidcSettings.authority}/account?referrer=${oidcSettings.clientId}&referrer_uri=${window.location.href}`;
        window.open(newTabAddress, '_blank', 'noopener,noreferrer');
    },
};

const router = createRouter({
    routes,
    history: createWebHistory(),
});
router.beforeEach(vuexOidcCreateRouterMiddleware(store as any));

export default router;
